<template>
  <div class="login">
    <b-container>
      <h2 class="section-heading">Create Password</h2>
      <b-row>
        <b-col>
          <div class="login-card">
            <b-form v-if="canConfirm && !confSuccess">
              <!-- password -->
              <label>Password</label><br>
              <b-input-group>
                  <b-form-input
                  :class="{
                    'is-valid': !$v.user.password.$error && user.password,
                    'is-invalid': $v.user.password.$error && $v.user.password.$dirty
                  }"
                  v-model="$v.user.password.$model"
                  :type="passwordType"
                  class="password-input"
                  />
                  <b-input-group-prepend is-text 
                    class="password-icon-wrapper" 
                    @click="toggleShowPassword('password')"
                    :class="{
                    'goodPassword': !$v.user.password.$error && user.password,
                    'badPassword': $v.user.password.$error && $v.user.password.$dirty
                  }" 
                  >
                    <b-icon 
                    font-scale="1.5" 
                    :icon="passwordType === 'password'? 'eye-fill' : 'eye-slash-fill'"
                    class="eye-icon" 
                    />
                  </b-input-group-prepend>
              </b-input-group>
              <!-- Password -->
              <label class="mt-3">Confirm Password</label>
              <b-input-group
              >
                <b-form-input
                  :class="{
                    'is-valid': !$v.user.passwordConfirm.$error && user.passwordConfirm,
                    'is-invalid': $v.user.passwordConfirm.$error && $v.user.passwordConfirm.$dirty
                 }"
                  v-model="$v.user.passwordConfirm.$model"
                  :type="confirmPasswordType"
                  class="password-input"
                />
                <b-input-group-prepend 
                is-text 
                class="password-icon-wrapper" 
                @click="toggleShowPassword('confirm password')"
                :class="{
                    'goodPassword': !$v.user.passwordConfirm.$error && user.passwordConfirm,
                    'badPassword': $v.user.passwordConfirm.$error && $v.user.passwordConfirm.$dirty
                 }" 
                >
                  <b-icon 
                  font-scale="1.5" 
                  :icon="confirmPasswordType === 'password'? 'eye-fill' : 'eye-slash-fill'"
                  />
                </b-input-group-prepend>
              </b-input-group>

              <!--Confirm-->
              <b-form-group class="mt-3">
                <BtnMain @btnClicked="handleConfirm"
                  text="Confirm Password"
                  btnClass="confirm-btn"
                  variant="success"
                />
              </b-form-group>
            </b-form>
            <b-form-group v-if="confSuccess || confError">
                <b-alert
                  show
                  :variant="confSuccess ? 'success' : 'danger'"
                >
                  <p>{{ confMsg }}</p>
                </b-alert>
              </b-form-group>
            <!-- Error alert for unable to confirm -->
            <b-form-group v-if="!canConfirm">
                <b-alert
                  show
                  variant="danger"
                >
                  <p>{{ confMsg }}</p>
                </b-alert>
              </b-form-group>
              <div
                v-if="canConfirm && !confSuccess"
                class="d-flex flex-row justify-content-center">
                <ul class="mt-5 ml-3 password-requirements">
                Your password must contain:
                  <li>Minimum 10 characters</li>
                  <li>Minimum 1 uppercase letter</li>
                  <li>Minimum 1 lowercase letter</li>
                  <li>Minimum 1 Number</li>
                  <li>Minimum 1 Special Character (#?!@$%^&*-)</li>
                </ul>
              </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { checkCanConfirm, confirmRegistration } from '../services/api'
import BtnMain from '../components/BtnMain'
import { required, sameAs, minLength } from 'vuelidate/lib/validators'
export default {
  components: {
    BtnMain
  },
  data () {
    return {
      user: {
        password: '',
        passwordConfirm: ''
      },
      confSuccess: false,
      confError: false,
      confMsg: '',
      canConfirm: true,
      passwordType: "password",
      confirmPasswordType: "password",
      token: ''
    }
  },
  async mounted () {
    if (this.$route.query.token) {
      this.token = this.$route.query.token
      this.$store.dispatch('authStore/loginWithToken', this.$route.query.token, { root: true })
    } else {
      this.token = localStorage.getItem('token')
      if (this.token) {
        const res = await checkCanConfirm(this.token)
        if (res.data.success) {
          this.canConfirm = true
        } else {
          this.canConfirm = false
          this.confMsg = 'There was a problem confirming your registration, please try the link again later'
        }
      } 
      else {
        this.$router.push('/login')
      }
    }
  },
  methods: {
    async handleConfirm () {
      this.$v.$touch()
      if (this.user.password === this.user.passwordConfirm && !this.$v.$invalid) {
        const res = await confirmRegistration(this.token, this.user)
        if (res && res.data && res.data.success) {
          this.confError = false
          this.confSuccess = true
          window.scroll({
            top: 0,
            behavior: 'instant'
          })
          this.confMsg = 'Thank you for creating a password. You will now be taken to phone code confirm page.'
          setTimeout(() => {
            this.$router.push('/confirm-phone')
          }, 2500)
        } else {
          this.confError = true
          this.confMsg = 'There was an issue confirming your password, please try again later'
          setTimeout(() => {
            if (!this.confSuccess) {
              this.confError = false
              this.confMsg = ''
            }
          }, 5000)
        }
      } else {
        this.confError = true
        this.confMsg = 'Please ensure all fields are complete and that your passwords match'
        setTimeout(() => {
          if (!this.confSuccess) {
            this.confError = false
            this.confMsg = ''
          }
        }, 5000)
      }
    },
    toggleShowPassword(field){
      if (field === "password"){
        this.passwordType === "password"? this.passwordType = "text" : this.passwordType = "password"
      } else if (field === "confirm password") {
        this.confirmPasswordType === "password"? this.confirmPasswordType = "text" : this.confirmPasswordType = "password"
      }
    }
  },
  validations: {
    user: {
      password: {
        required: required,
        minLength: minLength(10),
        containsLowerCase: function(){
          return /[a-z]/.test(this.user.password)
        },
        containsUpperCase: function(){
          return /[A-Z]/.test(this.user.password)
        },
        containsNumber: function() {
          return /[0-9]/.test(this.user.password)
        },
        containsSpecialChar: function() {
          return /[#?!@$%^&*-]/.test(this.user.password)
        }
      },
      passwordConfirm: {
        required: required,
        sameAs: sameAs(function() {
          return this.user.password
        })
      }
    }
  }
}
</script>

<style scoped>
.password-input{
  border-right: none;
}
.password-icon-wrapper > *{
  background-color: white;
}
.badPassword > *{
  border: 1px solid #df3f4e;
  border-left: none;
}
.goodPassword > *{
  border: 1px solid #52b869;
  border-left: none;
}
.password-icon-wrapper > *:hover{
  color: green;
  cursor: pointer;
}
.password-requirements{
  color: grey;
  font-size: 0.8rem;
}
</style>